import React from 'react';
import { Form, Field, FieldProps } from 'formik';
import FormField from '../../../../../../../ui/DataEntry/FormField/FormField';
import Label from '../../../../../../../ui/DataEntry/Label/Label';
import Select from '../../../../../../../ui/DataEntry/Select/Select';
import { GenericDropdownOption } from '../../../../../../../App.types';
import { StylesConfig } from 'react-select';
import FileUpload, { ImagePreview } from '../../../../../../../ui/DataEntry/FileUpload/FileUpload';
import styles from './CollectionForm.module.css';
import { TiktokAudioCollectionWrite } from '@round/api';

type CollectionFormProps = {
    clientOptions: GenericDropdownOption<number>[];
};

export type CollectionFormValues = Omit<TiktokAudioCollectionWrite, 'client'> & {
    client: GenericDropdownOption<number> | null;
    image: File[];
};

const selectStyles: StylesConfig = {
    control: (provided) => ({
        ...provided,
        borderColor: '#c2cfe0',
        fontSize: '0.8125rem',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#90a0b7',
    }),
    input: (provided) => ({
        ...provided,
        height: 'auto',
    }),
};

const CollectionForm = ({ clientOptions }: CollectionFormProps) => (
    <Form>
        <FormField>
            <Label htmlFor="client">Client</Label>
            <Field name="client">
                {(props: FieldProps) => (
                    <Select
                        id="client"
                        styles={selectStyles}
                        placeholder="Select client"
                        value={props.field.value}
                        options={clientOptions}
                        onChange={(value) => props.form.setFieldValue('client', value)}
                    />
                )}
            </Field>
        </FormField>
        <FormField>
            <Label htmlFor="name">Name</Label>
            <Field name="name" id="name" placeholder="Enter name" />
        </FormField>
        <FormField>
            <Label htmlFor="image">Image</Label>
            <Field name="image" id="image">
                {(props: FieldProps) => (
                    <FileUpload
                        files={props.field.value}
                        onUpload={(files) => props.form.setFieldValue('image', files)}
                    >
                        {({ files: [imageFile] }) => <ImagePreview className={styles.imagePreview} file={imageFile} />}
                    </FileUpload>
                )}
            </Field>
        </FormField>
    </Form>
);

export default CollectionForm;
